export const formatTime = (date: string) => {
  const seconds = Math.round((Date.now() - new Date(date).getTime()) / 1000);

  if (seconds < 1) {
    return `Just now`;
  } else if (seconds < 60) {
    return `${seconds} seconds`;
  } else if (seconds >= 60 && seconds < 3600) {
    return `${Math.floor(seconds / 60)} minutes`;
  } else if (seconds >= 3600 && seconds < 86400) {
    return `${Math.floor(seconds / 3600)} hours`;
  } else {
    return `${Math.floor(seconds / 86400)} days`;
  }
};
